import { toast } from "react-toastify";

export function showToast(type, st) {
  var color = "green"
  if (type === "error") {
    color = "red"
  } else if (type === "info") {
    color = "green"
  }
 

  toast(
    <div
      rtl="true"
      dir="rtl"
      style={{
        height: "100%",
        borderRight: "5px solid " + color,
        display: "flex",
        alignItems: "center",
        paddingLeft: 5,
        direction: "rtl"
      }}
    >
      
      <div  rtl="true" dir="rtl" style={{ marginRight: 10, direction: "rtl" }}>
        {st}
      </div>
    </div>
  );
}